import "./App.scss";
import { Routes } from "./routes";
import useAutoLogout from "./customHooks/useAutoLogout";
import { Toaster } from "./components/shadcn-ui/toaster";

const App = () => {
  useAutoLogout();

  return (
    <div>
      <Routes />
      <Toaster />
    </div>
  );
};

export default App;
